import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class PedidoEgreso {
  static ingresoPedido (cereal, cantidad) {
    const axios = getAxiosInstance()
    const promise = axios.post(`consulta_pedido_de_egreso_playa`,
      `{"valores": {"cereal": "${cereal}", "cantidad": "${cantidad}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then(response => (response.data[0] || {}))
  }

  static eliminarPedido (fecha) {
    const axios = getAxiosInstance()
    const pedido = `{"clave": {"fecha_de_pedido": "${fecha}"}}`
    const promise = axios.delete(`consulta_pedido_de_egreso_playa?r=${pedido}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then(response => (response.data[0] || {}))
  }

  static async getDataPedidosCamionesEnPlaya () {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_pedido_de_egreso_playa?r=` +
    `{"limite":50, "orden": ["d:fecha_de_pedido"]}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async getPedidoEgresoPlaya () {
    const axios = getAxiosInstance()
    return axios.get(`/pedido_de_egreso_playa_insatisfecho?r=` +
    `{"orden": ["d:fecha_de_pedido"]}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}

export default PedidoEgreso
